export const genericTableInitialState = {
    clickedPagesArray: [0],
};
